import { message } from 'ant-design-vue'
import { customSignUp } from '~/server/common'
import { useUserInfoStore } from '~/stores/useUserInfo'
import { getNoticeDialogConfig } from '~/utils/utils'
import { useWechatStore } from '~/stores/useWeChat'

declare const rongIMChat: any

export function userInfoAction() {
    type Callback = (arg: any) => any

    interface infoParamType {
      adviserList?: Array<any>
      floorId: number
      cityId: number
      source?: string
      message?: string
      adviserId?: number
      configId?: number
      title?: string
      content?: string
      bottomType?: number
      callPhone?: string
      theme?: string
      sourceTypeId?: number
      cb?: Callback
    }

    const store = useUserInfoStore()
    const wechatStore = useWechatStore()

    /**
     * 置业顾问微聊
     */
    async function commonCollect(info: infoParamType) {
      // 当前城市信息
      // const {city: cityId} = useCityInfoStore()
      // 用户信息
      const userInfo: any = await store.getUserInfo(true)
      if (userInfo?.isLogin) {
        const { userId } = userInfo
        // 已登录
        const { adviserList = [], floorId, message } = info || {}
        //  该楼盘存在置业顾问or直接指定置业顾问id
        if (adviserList?.length > 0 || info?.adviserId) {
          // 取缓存置业顾问
          const storageAdviser = wechatStore.getAdviser(floorId)
          let adviserId, index
          if (!info?.adviserId) {
            // 从置业顾问列表中随机选择一个置业顾问
            index = Math.floor(Math.random() * adviserList?.length)
            const { adviserId: tempAdviserId } = adviserList[index]
            adviserId = tempAdviserId
            if (storageAdviser !== null) {
              // 有缓存置业顾问
              const { adviserId: tempAdviserId } = storageAdviser
              const idx = adviserList.findIndex(i => i.adviserId === tempAdviserId)
              if (idx >= 0) {
                // 有缓存置业顾问，且存在列表中，覆盖随机置业顾问id，否则不做处理
                adviserId = tempAdviserId
              }
            }
            else {
              // 无置业顾问缓存，更新置业顾问缓存
              wechatStore.setAdviser({
                [floorId]: adviserList[index],
              })
            }
          }
          else {
            adviserId = info?.adviserId
            index = adviserList.findIndex(i => i.adviserId === info?.adviserId)
            // 更新置业顾问缓存
            wechatStore.setAdviser({
              [floorId]: adviserList[index],
            })
          }
          //  调用微聊sdk
          rongIMChat?.chatToUser(adviserId, 9)
          if (message)
            rongIMChat?.setTextMessage(message)
        }
        else if (info?.configId) {
          // 无置业顾问，调用报名接口
          await commonSignUp({
            ...info,
            theme: 'CONSULTANT',
          })
        }
      }
    }

    /**
     * 活动报名
     */
    async function commonSignUp(info: infoParamType) {
      return new Promise((resolve) => {
        // 当前城市信息
        const { city: cityId } = useCityInfoStore()
        const userInfo: any = store.getUserInfo()
        if (userInfo?.isLogin) {
          const { mobile } = userInfo
          // 已登录,获取报名信息
          const { floorId, configId, source, cb, sourceTypeId = 1, theme } = info || {}
          const params = {
            businessId: configId,
            cityId,
            floorId,
            mobile,
            source,
            sourceTypeId,
          }
          customSignUp(params).then((res) => {
            const { code } = res
            if (cb) {
              cb(res)
              return
            }
            if (code === 0) {
              const config: any = getNoticeDialogConfig({ theme, mobile })
              message.success(config?.toastText || '报名成功')
              return resolve(true)
            }
            else {
              return resolve(false)
            }
          })
        }
        else {
          // 未登录，跳转至登录界面
          window.location.href = `https://member.fccs.com/login.jhtml?forwardUrl=${encodeURIComponent(window.location.href)}`
        }
      })
    }

    return { commonCollect, commonSignUp }
}
